// extracted by mini-css-extract-plugin
module.exports = {"root":"TemplateSelection_root__2tZns"};